import { useQuery } from '@tanstack/react-query'
import { PublicTermsOfServiceEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetTermsOfServicePublic(termsOfServiceId: string): {
  termsOfService: PublicTermsOfServiceEntity
  isLoading: boolean
  isError: boolean
} {
  const {
    data: termsOfService,
    isLoading,
    isError,
  } = useQuery(['public', 'termsOfService', termsOfServiceId], async () => {
    return qoursesApi.legalPublic.legalPublicControllerGetTermsOfServiceByIdV1(termsOfServiceId)
  })

  if (termsOfService === undefined) {
    return { termsOfService: {} as PublicTermsOfServiceEntity, isLoading, isError }
  }

  return { termsOfService, isLoading, isError }
}
